// extracted by mini-css-extract-plugin
module.exports = {"tpl_snow":"snow_tpl_snow__AT2OO","nieve":"snow_nieve__CiTz4","horiz":"snow_horiz__rkG4K","horiz2":"snow_horiz2__YkURT"};